
Vue.config.productionTip = false

// Vant 组件库按需引入
import Vue from 'vue'
import { Overlay, Popup, Dialog, Area, Toast, SwipeCell, Picker, Switch, Collapse, CollapseItem, Swipe, SwipeItem, IndexBar, IndexAnchor, List, DatetimePicker, ImagePreview, Checkbox, Progress, Lazyload } from 'vant'
import 'vant/lib/overlay/style'
import 'vant/lib/popup/style'
import 'vant/lib/dialog/style'
import 'vant/lib/area/style'
import 'vant/lib/toast/style'
import 'vant/lib/swipe-cell/style'
import 'vant/lib/picker/style'
import 'vant/lib/switch/style'
import 'vant/lib/collapse/style'
import 'vant/lib/collapse-item/style'
import 'vant/lib/swipe/style'
import 'vant/lib/swipe-item/style'
import 'vant/lib/index-bar/style'
import 'vant/lib/index-anchor/style'
import 'vant/lib/list/style'
import 'vant/lib/datetime-picker/style'
import 'vant/lib/image-preview/style'
import 'vant/lib/checkbox/style'
import 'vant/lib/progress/style'

Vue.use(Overlay)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Area)

// Toast.setDefaultOptions({position: 'bottom'});
Vue.use(Toast)
Vue.use(SwipeCell)
Vue.use(Picker)
Vue.use(Switch)
Vue.use(Collapse).use(CollapseItem)
Vue.use(Swipe).use(SwipeItem)
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(List);
Vue.use(DatetimePicker);
Vue.use(ImagePreview);
Vue.use(Checkbox);
Vue.use(Progress);
Vue.use(Lazyload);

// 引入虚拟列表模板
import VirtualList from './modules/virtual/index'
Vue.component('virtual-list', VirtualList)

// 二维码组件导入
import VueQrcode from '@xkeshi/vue-qrcode'
Vue.component(VueQrcode.name, VueQrcode);

// 引入ECharts主模块 :: 引入柱状图
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

// 引入fundebug错误上报日志
// 开发环境屏蔽一下,不然太多不必要的报错了
import * as fundebug from "fundebug-javascript";
import fundebugVue from "fundebug-vue";
if (process.env.NODE_ENV == 'production') {
    fundebug.init({
        apikey: "e34c64bd78ff6a28f4558d513a6e366cf11a0219c85a1e6a6fb9d1d83ab390f9"
    });
    fundebugVue(fundebug, Vue);
}

// import mixpanel from 'mixpanel-browser'
// mixpanel.init('df0b183b34da6c9f8ddfd94670553944', {
//     debug: false,
//     track_pageview: false,
//     persistence: "localStorage",
// });

import _ from 'lodash'
Object.defineProperty(Vue.prototype, '$_', { value: _ });

// 样式库引入
import 'animate.css'
// basic part
import './assets/style/common.css'
import './assets/style/iconfont/iconfont.css'
import './assets/style/iconbg.css'
import './assets/style/video.css'
// layout part
import './assets/style/components.css'
import './assets/style/layout/layouts.css'
import './assets/style/layout/lo-import.css'
import './assets/style/layout/lo-collate.css'
import './assets/style/layout/lo-record.css'
import './assets/style/layout/lo-detail.css'
import './assets/style/layout/lo-diagram.css'
import './assets/style/layout/lo-search.css'
import './assets/style/layout/lo-fatefortune.css'
import './assets/style/layout/lo-reminder.css'
import './assets/style/layout/lo-inform.css'
import './assets/style/layout/lo-contrast.css'
import './assets/style/layout/lo-course.css'
import './assets/style/layout/lo-marriage.css'
// pages part
import './assets/style/pages.css'
import './assets/style/pages/pg-collate.css'
import './assets/style/pages/pg-diagram.css'
import './assets/style/pages/pg-comment.css'
import './assets/style/pages/pg-contrast.css'
import './assets/style/pages/pg-course.css'
import './assets/style/pages/pg-discuss.css'
import './assets/style/pages/pg-discusschoosepeople.css'
import './assets/style/pages/pg-discussmain.css'
import './assets/style/pages/pg-donate.css'
import './assets/style/pages/pg-report.css'
import './assets/style/pages/pg-label.css'
import './assets/style/pages/pg-pedia.css'
import './assets/style/pages/pg-pediacomment.css'
import './assets/style/pages/pg-my.css'
import './assets/style/pages/pg-nature.css'
import './assets/style/pages/pg-home.css'
import './assets/style/pages/pg-my-report.css'
import './assets/style/pages/pg-report-strong.css'
import './assets/style/pages/pg-generate.css'
import './assets/style/pages/pg-year.css'
import './assets/style/pages/pg-marriage.css'
import './assets/style/transition.css'
// calendar part
import './assets/style/pages/pg-calendar.css'
import './assets/style/calendar.css'

// 注册长按事件
Vue.directive('longpress', {
    
    bind: function(el, binding, vNode) {
        // 确保提供的表达式是函数
        if (typeof binding.value !== 'function') {
            // 获取组件名称
            const compName = vNode.context.name;
            // 将警告传递给控制台
            let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be `;
            if (compName) { warn += `Found in component '${compName}' `}

            console.warn(warn);
        }

        // 定义变量
        let pressTimer = null;

        // 定义函数处理程序
        // 创建计时器（ 1秒后执行函数 ）
        let start = (e) => {

            if (e.type === 'click' && e.button !== 0) {
                return;
            }

            if (pressTimer === null) {
                pressTimer = setTimeout(() => {
                    // 执行函数
                    handler();
                }, 1000)
            }
        }

        // 取消计时器
        let cancel = (e) => {

            // 检查计时器是否有值
            if ( pressTimer !== null ) {
                clearTimeout(pressTimer);
                pressTimer = null;
            }
        }

        // 运行函数
        const handler = (e) => {
            // 执行传递给指令的方法
            binding.value(e)
        }

        // 添加事件监听器
        el.addEventListener("mousedown", start);
        el.addEventListener("touchstart", start);

        // 取消计时器
        el.addEventListener("click", cancel);
        el.addEventListener("mouseout", cancel);
        el.addEventListener("touchend", cancel);
        el.addEventListener("touchcancel", cancel);
    }
});

// bus: 注意:在mounted的時候on，在destory的時候要off，避免重复触发
const Bus = new Vue({
    methods: {
        emit (event, ...args) {
            this.$emit(event, ...args)
        },
        on (event, callback) {
            this.$on(event, callback)
        },
        off (event, callback) {
            this.$off(event, callback)
        }
    }
})
Vue.prototype.$bus = Bus

// 功能插件模块引入:登录
import DeepSeekPlugin from './plugins/deepseek'
import './plugins/deepseek/style'
Vue.use(DeepSeekPlugin, {
    store: store
});


// 重写打印台
console.log = (function (oriLogFunc) {
    return function () {
      // 判断是否开启日志调试
      if (process.env.NODE_ENV != 'production') {
        try{
          oriLogFunc.call(console, ...arguments);
        }catch(e){
          console.error('console.log error', e);
        }
      }
    }
  })(console.log);
// 移动端打印log
// var vConsole = process.env.NODE_ENV == 'pre-release' ? new VConsole() : null;
// var vConsole = process.env.NODE_ENV == 'production' ? new VConsole() : null;

// 检查登录状态后:App开始初始化
// 嵌入式的页面不走微信授权登录接口，直接走url上的token
import login from './modules/login'
import store from './modules/store'
var pathName = window.location.pathname;
if(pathName.indexOf('embedded') != -1) {
    login.renderView();
}else {
    login.checkPlatForm();
}


// document.addEventListener('click', function() {}, {passive: true})
// document.addEventListener('touchstart', function() {}, {passive: true})
// document.addEventListener('touchmove', function() {}, {passive: true})
// document.addEventListener('scroll', function() {}, {passive: true})

// 解决click事件300ms延迟问题
// import fastclick from 'fastclick'
// fastclick.attach(document.body);

// import FastClick from 'fastclick'
// if ('addEventListener' in document) {
//     document.addEventListener('DOMContentLoaded', function() {
//         FastClick.attach(document.body);
//     }, false);
// }